import { render, staticRenderFns } from "./OnDemandView.vue?vue&type=template&id=0589cc59"
import script from "./OnDemandView.vue?vue&type=script&lang=js"
export * from "./OnDemandView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports